var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46781 3.28757C2.66099 3.28757 2.00758 3.93168 2.00758 4.7179L2 16.1587C2 16.9449 2.65341 17.589 3.46023 17.589H12.2727C13.0796 17.589 13.7406 16.9449 13.7406 16.1587V7.87385C13.7406 7.68376 13.6629 7.50289 13.5265 7.36816L9.55305 3.49612C9.41479 3.36139 9.22918 3.28757 9.03411 3.28757H3.46781Z",
    fill: "#150B99",
    stroke: "#1155BB",
    strokeWidth: 0.847324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6968 9.48469H6.40324C5.86246 9.48469 5.42407 9.91188 5.42407 10.4389V13.7738C5.42407 14.3008 5.86246 14.728 6.40324 14.728H15.6968C16.2376 14.728 16.676 14.3008 16.676 13.7738V10.4389C16.676 9.91188 16.2376 9.48469 15.6968 9.48469Z",
    fill: "url(#paint0_linear_1385_17794)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1968 11.609L8.92786 10.3853H9.62483L8.57369 12.0667L9.64945 13.7757H8.9449L8.1968 12.5336L7.44679 13.7757H6.74414L7.82179 12.0667L6.76876 10.3853H7.46573L8.1968 11.609ZM10.7006 13.3032H12.2801V13.7738H10.0964V10.3853H10.7006V13.3032ZM14.5604 12.9009C14.5604 12.7514 14.5074 12.637 14.3995 12.5557C14.2915 12.4745 14.0983 12.3933 13.818 12.3121C13.5377 12.2291 13.3142 12.1386 13.1495 12.0371C12.8332 11.8433 12.6741 11.5905 12.6741 11.2786C12.6741 11.0055 12.7877 10.7803 13.0169 10.6031C13.246 10.4259 13.5415 10.3373 13.907 10.3373C14.1495 10.3373 14.3654 10.3816 14.5548 10.4684C14.7442 10.5551 14.8938 10.6788 15.0017 10.8393C15.1097 10.9999 15.1646 11.1771 15.1646 11.3727H14.5623C14.5623 11.1955 14.5055 11.0571 14.3919 10.9575C14.2782 10.8578 14.1154 10.808 13.9032 10.808C13.7063 10.808 13.5529 10.8486 13.443 10.9316C13.3332 11.0147 13.2801 11.1291 13.2801 11.2768C13.2801 11.4004 13.3389 11.5038 13.4563 11.5868C13.5737 11.6699 13.7688 11.7511 14.0396 11.8286C14.3104 11.9061 14.5282 11.9965 14.6911 12.0962C14.8559 12.1959 14.9752 12.3103 15.051 12.4413C15.1267 12.5705 15.1665 12.7218 15.1665 12.8972C15.1665 13.1796 15.0548 13.4047 14.8332 13.5708C14.6116 13.7369 14.3104 13.8218 13.9298 13.8218C13.6779 13.8218 13.4468 13.7757 13.2366 13.6852C13.0264 13.5948 12.8616 13.4693 12.7442 13.3087C12.6267 13.1482 12.568 12.9636 12.568 12.7495H13.1722C13.1722 12.9415 13.2366 13.091 13.3673 13.1962C13.4979 13.3014 13.6854 13.3549 13.9279 13.3549C14.1381 13.3549 14.2953 13.3143 14.4014 13.2312C14.5074 13.1482 14.5604 13.0393 14.5604 12.9027V12.9009Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72021 7.11728V1L18.9999 7.72995H10.565C10.0991 7.72995 9.72021 7.4552 9.72021 7.11728Z",
    fill: "white",
    stroke: "#1155BB",
    strokeWidth: 0.378974,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_17794",
    x1: 4.32754,
    y1: 11.7168,
    x2: 16.0805,
    y2: 11.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1866C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportador);
export default __webpack_public_path__ + "static/media/importador.3316f2bdf303e46ccfe7794e620a4ea1.svg";
export { ForwardRef as ReactComponent };